import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-text-md" }
const _hoisted_2 = { class: "p-text-md" }

import { reactive } from 'vue';
import { servicesService } from '@/api/services/service';
import { useSettingsStore } from '@/api/store/settings';


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceSelector',
  setup(__props) {

const state = reactive({
    services: [],
});

const settingsStore = useSettingsStore();

const fetchServices = async () => {
    servicesService.index().then((response) => {
        state.services = response.data;
    }).catch((error) => {
        console.log(error);
    }).finally(() => {
        console.log('done');
    });
};

fetchServices();

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.services, (service) => {
        return (_openBlock(), _createBlock(_component_v_row, {
          key: service.id,
          class: "mb-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "mt-2" }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_1, _toDisplayString(service.name) + " (" + _toDisplayString(service.booking_options.duration) + " mins)", 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_v_col, {
              cols: "2",
              class: "mt-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_2, _toDisplayString(service.price_display), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_v_col, {
              cols: "3",
              class: "text-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  class: "text-white",
                  color: _unref(settingsStore).settings.buttonColor,
                  onClick: ($event: any) => (_ctx.router.push({ name: 'create-appointment', params: { id: service.id } }))
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("View", -1)
                  ]))]),
                  _: 1
                }, 8, ["color", "onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})